import { render, staticRenderFns } from "./PeriodSelector.vue?vue&type=template&id=89f520a2&scoped=true"
import script from "./PeriodSelector.vue?vue&type=script&lang=js"
export * from "./PeriodSelector.vue?vue&type=script&lang=js"
import style0 from "./PeriodSelector.vue?vue&type=style&index=0&id=89f520a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f520a2",
  null
  
)

export default component.exports